@if ((item$ | async)?.productionRoute; as productionRoute) {
  <elder-basic-pane-layout class="full">
    <elder-pane class="outlined">
      <elder-table
        class="flex"
        matSort
        [data]="productionRoute?.sequence"
        [interactionMode]="'selection'"
        (selectionSingleChange)="segment$.next($event)"
      >
        <!-- id Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
            {{ 'context.id' | translate }}
          </th>
          <td mat-cell *matCellDef="let i = index">#{{ i }}</td>
        </ng-container>
        <!-- capability Column -->
        <ng-container matColumnDef="capability">
          <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
            {{ 'context.name' | translate }}
          </th>
          <td mat-cell *matCellDef="let op">{{ op.capability }}</td>
        </ng-container>
        <!-- workCenterNumber Column -->
        <ng-container matColumnDef="workCenterNumber">
          <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
            {{ 'shopfloor.workcenters.workcenter' | translate }}
          </th>
          <td mat-cell *matCellDef="let op">{{ op.workCenterNumber }}</td>
        </ng-container>
        <!-- state Column -->
        <ng-container matColumnDef="state">
          <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
            {{ 'context.status' | translate }}
          </th>
          <td mat-cell *matCellDef="let op">
            <div class="layout-row place-start-center gap-sm">
              <div>{{ 'WorkItemState.' + op.state | translate }}</div>
              @if (op.validationState !== ValidationState.VALIDATED) {
                <div class="flex layout-row place-start-center">
                  <mat-icon color="warn" matTooltip="{{ 'manufacturing.title' | translate }}"
                    >error</mat-icon
                  >
                </div>
              }
            </div>
          </td>
        </ng-container>
      </elder-table>
    </elder-pane>
    <app-item-work-segment [segment]="segment$ | async" class="flex-50"></app-item-work-segment>
  </elder-basic-pane-layout>
}
